import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import { CookiesProvider } from 'react-cookie';
import {store} from "./reducers/store";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <CookiesProvider defaultSetOptions={{ path: '/' }}>
    <Provider store={store}>
          {/*<React.StrictMode>*/}
              <App />
          {/*</React.StrictMode>*/}
      </Provider>
  </CookiesProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
